module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab109-ea4d4c37d9eed00c9a57c79e3541da5d.jpg";